/**
 * Update Study Dialog Context Hook
 *
 * Migrated from: lego/page/etmf/overview/update-study/context/useDialogContext.jsx
 *
 * Custom hook to access the Update Study wizard context.
 * Throws an error if used outside of DialogContext.Provider.
 */

import { useContext } from 'react'
import { DialogContext, type DialogContextValue } from './DialogContext'

export const useDialogContext = (): DialogContextValue => {
  const context = useContext(DialogContext)

  if (context === null) {
    throw new Error('useDialogContext must be used within a DialogContext.Provider')
  }

  return context
}
